<template>
  <Row>
    <Column :width="15">
      <transition name="rc-modal-fade">
        <div v-if="ready" class="rc-modal-backdrop">
          <div class="rc-modal">

            <Box>
              <TitleRow :left="4" :right="4"> {{ MC.Sign.Out.Title.value() }} </TitleRow>
              <ErrorRow :error="error" />
              <SpacerRow />
              <Row>
                <Column :width="3" />
                <Column :width="9">
                  <SpacerRow />
                  <Value align="centre" fontSize="large"> {{ MC.Sign.Out.Message.value() }} </Value>
                  <SpacerRow />
                </Column>
                <Column :width="3" />
              </Row>

              <Row>
                <Column :width="3" />
                <Column :width="4">
                  <Button v-on:click="back(false)" padding="5px">Back</Button>
                </Column>
                <Column :width="1" />
                <Column :width="4">
                  <Button :go="true" v-on:click="back(true)"> {{ MC.Sign.Out.Confirm.value() }} </Button>
                </Column>
                <Column :width="3" />
              </Row>
              <SpacerRow />
            </Box>
          </div>
        </div>

      </transition>
    </Column>
  </Row>
</template>

<script>

import MC from "@/domain/session/MC.js";
import { mapActions, mapGetters, mapMutations } from 'vuex';

import UserEvents from '@/domain/model/user/UserEvents.js';
import ConstUtils from '@/utils/ConstUtils.js';
import ContentUtils from '@/utils/ContentUtils.js';
import StringUtils from '@/utils/StringUtils.js';

import Box from "@/portals/shared/library/box/Box.vue";
import Column from "@/portals/shared/library/box/Column.vue";
import Row from "@/portals/shared/library/box/Row.vue";

import Button from "@/portals/shared/library/button/Button.vue";
import Value from "@/portals/shared/library/value/Value.vue";

import SpacerRow from "@/portals/shared/library/spacer/SpacerRow.vue";

import ErrorRow from '@/components/row/ErrorRow.vue';
import TitleRow from "@/portals/shared/library/title/TitleRow.vue";

export default {
  name: "sign-out-dialog",
  components: {
    Box, Row, Column,
    TitleRow, SpacerRow,
    Button, Value,
    ErrorRow,
  },
  props: {
    isAdmin: { type: Boolean, default: false },
    inspectionId: { type: String, default: "" },
  },
  data() {
    return {
      error: null,
      missing: false,

      isLoading: true,
      loadingMessage: null,
      MC: new MC(),
      Consts: ConstUtils,

      Strings: StringUtils,
      Contents: ContentUtils,

      Fields: {
        EMAIL: "email",
      },
      kvps: {},
      isSending: false,
      ready: false,
    };
  },
  computed: {
    ...mapGetters([
      'auth_connected',
      'auth_socket_status',
      'signin_event',
      'auth_client',
      'domain',
    ]),
    itemId: function () {
      return this.$route.params['id'];
    },
  },
  watch: {

  },
  mounted: function () {
    this.ready = true;
  },
  methods: {
    ...mapActions([
      'AuthStorage_updateCompany',
      'addListenerAction',
      'removeListenerAction',
      'updateDomain',
    ]),
    ...mapMutations([
      'authClear',
    ]),

    start: function () {
      this.isLoading = false;
      this.loadingMessage = this.MC.Status.Loading.value();
    },

    callback: function (msg) {
      this.loadingMessage = msg;
    },
    back: function (good) {
      if (good) {
        this.doneSignOut();
      } else {
        this.$emit("close", good);
      }
    },
    signOut: function () {
      this.doneSignOut();
    },

    listener: function (event) {
      if (event.is(UserEvents.SignOut.Names.Response)) {
        if (event.error()) {
          this.error = event.error();
        } else {
          this.doneSignOut()
        }
      }
    },

    doneSignOut: function () {
      this.authClear();
      var value = window.localStorage["readyChek"];
      var cookieData = {};

      if (value) {
        cookieData = JSON.parse(value);
      }
      if (cookieData) {
        cookieData["auto"] = false;
        delete cookieData['Company'];
        var cookieString = JSON.stringify(cookieData);
        window.localStorage.readyChek = cookieString;
      }
      this.domain.cleanup();
      this.domain.signOut();
      this.AuthStorage_updateCompany(null);
      this.$emit("close", true);
    }
  },
}
</script>